<script lang="ts">
  import VerifiableLogo from '$shared/images/verifiable-logo.svg';
  import Tooltip from '$shared/atoms/Tooltip/Tooltip.svelte';
  import { EmptyLabelDefault } from '$shared/constants/global';
  import type { VerificationOverviewTableRow } from '$shared/models/VerificationOverviewTableRow';

  interface Props {
    row: VerificationOverviewTableRow;
    column: ColumnType;
  }

  let { row, column }: Props = $props();

  const TooltipLabel = 'Verified';
</script>

<div class="comp-verified-overview-cell">
  {#if !row?.isLoading && row?.isVerified}
    <div class="verified">
      <Tooltip label={TooltipLabel} top>
        <div class="icon-logo"><img src={VerifiableLogo} alt="verifable" /></div>
      </Tooltip>
    </div>
  {:else}
    {EmptyLabelDefault}
  {/if}
</div>

<style>
  .icon-logo {
    width: 16px;
    height: 16px;
  }
  .verified {
    display: flex;
    flex-direction: row;
  }
  .comp-verified-overview-cell img {
    width: 100%;
  }
</style>
